import { TableCell } from "@mui/material";
import { StyledTableRow } from "../../components/Table/Table";
import ConfigurationReadyChip from "../../components/payments/ConfigurationReadyChip/ConfigurationReadyChip";
import { PaymentConfiguration } from "../../types/payments";

export default function ConfigurationRow({
  configuration,
  onSelect
}: {
  configuration: PaymentConfiguration;
  onSelect: (configuration: PaymentConfiguration) => void;
}) {
  return (
    <StyledTableRow
      onClick={() => onSelect(configuration)}
      sx={{ cursor: "pointer" }}
    >
      <TableCell align="left">{configuration.organizationName}</TableCell>
      <TableCell align="center">{configuration.fiscalId}</TableCell>
      <TableCell align="center">
        <ConfigurationReadyChip configuration={configuration} />
      </TableCell>
    </StyledTableRow>
  );
}
